import React from "react";
import { useTranslation } from "react-i18next";
import {
  useCreateCostProfile,
  useRetrieveCurrentPlanzone,
} from "@planzone/view-models";
import { costProfile, CostProfile } from "@planzone/dto";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { Form } from "./form";
import { Props } from "./types";
import styles from "./styles.scss";

function CostProfileCreation({ cancel }: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { isRequestPending: isEditionRequestPending, createCostProfile } =
    useCreateCostProfile();
  const [formData, setFormData] = React.useState<CostProfile>(costProfile);

  return (
    <Modal header={t("createCostProfile.title")} close={cancel}>
      <form
        className={styles.costProfileCreation}
        onSubmit={(e) => {
          e.preventDefault();

          !isEditionRequestPending &&
            createCostProfile({ planzone, costProfile: formData });
        }}
      >
        <div className={styles.form}>
          <Form formData={formData} edit={setFormData} />
        </div>
        <div className={styles.footer}>
          <Button type="cancel" press={cancel}>
            {t("createCostProfile.cancel")}
          </Button>
          <Button
            type="submit"
            status={isEditionRequestPending ? "pending" : "none"}
            isDisabled={isEditionRequestPending}
          >
            {t("createCostProfile.submit")}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export { CostProfileCreation };
